import { render, staticRenderFns } from "./clinic-patient-csv-uploader.vue?vue&type=template&id=0325c47f&scoped=true"
import script from "./clinic-patient-csv-uploader.vue?vue&type=script&lang=js"
export * from "./clinic-patient-csv-uploader.vue?vue&type=script&lang=js"
import style0 from "./clinic-patient-csv-uploader.vue?vue&type=style&index=0&id=0325c47f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0325c47f",
  null
  
)

export default component.exports